import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from, Observable, of, switchMap } from 'rxjs';
import { SecurityService } from "../services/security.service"
import { environment } from '../../../environments/environment.dev';

@Injectable({
  providedIn: 'root',
})
export class GraphService {


  securityService: SecurityService = inject(SecurityService);
  http = inject(HttpClient);

  private _graphPhotoEndpoint = environment.graphConfig.graphPhotoEndpoint;

  public getProfilePicture(): Observable<Blob> {

    if (!this.securityService.hasActiveAccount) {
      console.error('No active account found');
      return from(Promise.reject('No active account found'));
    }

    return from(this.securityService.acquireToken()).pipe(
      switchMap((accessToken) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${accessToken}`
        });

        return this.http.get(this._graphPhotoEndpoint, { headers, responseType: 'blob' });
      })
    );
  }
}
